import { render, staticRenderFns } from "./RegisterDorm.vue?vue&type=template&id=544620ec&"
import script from "./RegisterDorm.vue?vue&type=script&lang=js&"
export * from "./RegisterDorm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDorm.vue?vue&type=style&index=0&id=544620ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports